import { FullscreenOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useState } from "react";
import VideoContentLoading from "./VideoContentLoading";

type Props = {
  url: string;
  title: string;
  loading?: boolean;
};

export default function EmbedContent({ url, title, loading }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (loading) {
    return <VideoContentLoading />;
  }

  // Google Docs Viewer URL
  const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
    url,
  )}&embedded=true`;

  return (
    <section>
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-theme-slate-700 text-2xl font-semibold leading-6">
          {title}
        </h3>
      </div>

      <div className="relative w-full aspect-video border border-theme-zinc-200 rounded-lg overflow-hidden">
        <iframe
          src={viewerUrl}
          title={title}
          className="w-full h-full"
          frameBorder="0"
        ></iframe>

        {/* Overlay to block the Google Docs "Pop-out" button */}
        <button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center gap-2 text-theme-primary hover:text-theme-primary/80 transition-colors absolute top-2 right-3 size-12 z-10 bg-[#2d2f31] rounded justify-center"
        >
          <FullscreenOutlined className="text-2xl" />
        </button>
      </div>

      <Modal
        title={title}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="90%"
        style={{ top: 20 }}
        className="full-screen-modal"
        styles={{ body: { height: "calc(100vh - 100px)", padding: 0 } }}
      >
        <div className="w-full h-full relative">
          <iframe
            src={viewerUrl}
            title={title}
            className="w-full h-full rounded-b-lg"
            frameBorder="0"
          ></iframe>
          {/* Overlay to block the Google Docs "Pop-out" button in modal */}
          <div className="absolute top-2 right-3.5 w-12 h-12 z-10 bg-[#313131]" />
        </div>
      </Modal>
    </section>
  );
}
